import { createSlice } from '@reduxjs/toolkit';

/**
 * @typedef {import('@reduxjs/toolkit').PayloadAction} PayloadAction
 */
/**
 * @typedef {import('../../index.d.ts').ToastProps} ToastProps
 */

const toastSlice = createSlice({
  name: 'toast',
  /**
   * @type {Array<ToastProps>}
   */
  initialState: [],
  reducers: {
    hideToast(state) {
      if (state.length > 0) state[0].id = 0;
    },
    dequeueToast(state) {
      state.splice(0, 1);
    },
    /**
     *
     * @param state
     * @param {PayloadAction<ToastProps>} payload
     */
    enqueueToast(state, { payload }) {
      if (payload.id && payload.text) state.push(payload);
    },
  },
});

export default toastSlice;
export const { hideToast, dequeueToast, enqueueToast } = toastSlice.actions;
